import React from 'react';
import IconCircle from './IconCircle';

export default function AiPoweredSection({styles}) {
  return (
    <section className={`${styles.container} ${styles.aiPoweredSection}`}>

          <div className={`${styles.columnCard} ${styles.aiPowered}`}>
            <div className={`${styles.columnText} half-width`}>
              <h2 className={styles.columnTextHeading}>
                AI-Powered campaigns that get smarter
              </h2>
              <p className={styles.columnTextPara}>
                Create intelligent campaigns that improve with each send.{" "}
              </p>
              <p className={styles.columnTextPara}>
                Our AI pinpoints your top customers, tailors messages to their
                actions, and enhances content performance while offering
                suggestions for better results, allowing you to concentrate on
                growth instead of email tasks.
              </p>
            </div>
            <div className={`${styles.aiPoweredColumnImage} half-width`}>
              <img
                className={styles.aiPoweredImage}
                src="/images/dogEmail.webp"
                alt="Automated example."
              />
              <div className={styles.aiPoweredStepIcon}>
                <IconCircle
                  icon={
                    <img
                      src="/images/icons/ai-logo-black.webp"
                      alt="AI logo black"
                    />
                  }
                />
              </div>

              <IconCircle
                icon={
                  <img
                    src="/images/icons/paperPlaneIcon.webp"
                    alt="Paper plane icon"
                  />
                }
                containerStyle={{
                  position: "absolute",
                  left: "-10px",
                  bottom: "60px",
                }}
              />
            </div>
          </div>

        </section>
  );
}